import { render, staticRenderFns } from "./BulkEventInsertion.vue?vue&type=template&id=0ce9a478&scoped=true"
import script from "./BulkEventInsertion.vue?vue&type=script&lang=js"
export * from "./BulkEventInsertion.vue?vue&type=script&lang=js"
import style0 from "./BulkEventInsertion.vue?vue&type=style&index=0&id=0ce9a478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce9a478",
  null
  
)

export default component.exports